import searchInputView from './searchInputComponent.html';
import './searchInputComponent.css';

export function searchInputComponent() {
	return {
		bindings: {
			model: '=',
			placeholder: '@?',
			size: '<?',
			onClear: '&?',
			onSubmit: '&?',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: searchInputComponentCtrl,
		template: searchInputView,
	};
}

export class searchInputComponentCtrl {
	/**
	 * Save injections and setup watchers
	 * @param $scope
	 * @param $timeout
	 */
	constructor($scope, $timeout) {
		'ngInject';
		this.$timeout = $timeout;
		$scope.$watch('vm.model', newVal => (this.inputText = newVal));
	}

	/**
	 * Respond to form submission
	 */
	doSubmit() {
		this.model = this.inputText;
		// use $timeout so that parent scope has time to digest model change
		this.onSubmit && this.$timeout(() => this.onSubmit());
	}

	/**
	 * Respond to the X icon click
	 */
	doClear() {
		this.inputText = '';
		this.model = '';
		// use $timeout so that parent scope has time to digest model change
		this.$timeout(() => {
			if (this.onClear) {
				this.onClear();
			} else if (this.onSubmit) {
				this.onSubmit();
			}
		});
	}
}
